import React from 'react';
import { useParams } from 'react-router-dom';
import { LandingView } from '../components/public/LandingView';
import { normalizePublicSlug } from '../config/app';

/** Landing pública de cualquier empresa: /landing/:slug y /:slug */
export function PublicLanding() {
  const {
    slug = ''
  } = useParams();
  // El slug se normaliza (espacios, %20, barras y mayúsculas) para que
  // /adrian1, /adrian1/ y /adrian1%20 resuelvan a la misma página.
  return <LandingView slug={normalizePublicSlug(slug)} data-id="element-2130" data-mp="sz4mso7k4myx" />;
}